/*
  Optimistic auth cache. Firebase auth hydrates asynchronously (onAuthStateChanged resolves AFTER mount
  and awaits a Firestore profile read), so without this the app renders the signed-out / default state
  for ~1-2s on every load before the real user appears. We snapshot the resolved user + preferences to
  localStorage and preload them synchronously at boot, so real values show immediately. onAuthStateChanged
  remains the source of truth and corrects the cache (e.g. clears it if the session actually expired).
*/
const KEY = 'p5-user-cache';

export interface UserCache {
  user: Record<string, unknown>;
  preferences: Record<string, unknown>;
}

export function saveUserCache(cache: UserCache): void {
  try {
    localStorage.setItem(KEY, JSON.stringify(cache));
  } catch (error) {
    // private mode / quota / no localStorage — caching is best-effort
  }
}

export function loadUserCache(): UserCache | null {
  try {
    const stored = localStorage.getItem(KEY);
    return stored ? (JSON.parse(stored) as UserCache) : null;
  } catch (error) {
    return null;
  }
}

export function clearUserCache(): void {
  try {
    localStorage.removeItem(KEY);
  } catch (error) {
    // ignore
  }
}
